import PlainTextCell from 'components/PlainTextCell';

type Props = {
  rowData: Pick<SentinelTeam, 'totals' | 'scheduledForDeletionAt'>;
};

export default function EnabledAssetsCell({
  rowData: { totals, scheduledForDeletionAt },
}: Props) {
  return (
    <PlainTextCell
      textAlign="end"
      color={scheduledForDeletionAt ? 'alaskanHusky' : undefined}
      topLine={totals?.assetGroupings?.enabledAssets}
    />
  );
}
